export default __webpack_public_path__ + "static/apercu-medium-25cf61d487ab2c3a8a85797932ac8073.woff";